import { fisicoDe, idProdutoDe, nomeDe } from './produto.js';
/** Preço com duas casas, tolerando vírgula decimal. Mesma conversão do 1.x. */
function preco(valor) {
    const n = typeof valor === 'string' ? Number.parseFloat(valor.replace(',', '.')) : Number(valor ?? 0);
    return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0;
}
/**
 * Monta o payload a partir do produto.
 *
 * `quantidade` sobrescreve o físico do produto: o reenvio de pendências manda **o valor
 * enviado na primeira vez**, não o atual — é aquele que precisa entrar no ERP.
 *
 * Nunca monte o objeto à mão no lugar de chamar isto. Foi exatamente assim que os campos
 * se perderam.
 */
export function montarEnvio(produto, quantidade = fisicoDe(produto)) {
    return {
        IdProduto: Number.parseInt(String(idProdutoDe(produto) ?? 0), 10) || 0,
        // Fracionário o ERP recusa; negativo o 1.x grampeava em zero.
        Quantidade: Math.max(0, Math.round(Number(quantidade) || 0)),
        CodigoBarras: String(produto.codigoBarras ?? produto.CodigoBarras ?? '').trim(),
        NomeProduto: nomeDe(produto),
        // A Nuvem3 pede o campo; o 1.x sempre mandou 0 e o Themis não gerencia estoque mínimo.
        EstoqueMinimo: 0,
        PrecoVenda: preco(produto.PrecoVenda ?? produto.precoVenda),
        PrecoCusto: preco(produto.PrecoCusto ?? produto.precoCusto),
    };
}
//# sourceMappingURL=erp-payload.js.map